import React from "react";
import "./CSS/Styled.css";
import { Link } from "react-router-dom";

import img1 from "./IMAGES/1 Twinkle.png";
import img2 from "./IMAGES/2 Twinkle.png";
import img3 from "./IMAGES/3 twinkle.png";
import img4 from "./IMAGES/4 twinkle.png";
import img5 from "./IMAGES/5 twinkle.png";
import img6 from "./IMAGES/6 twinkle.png";
import img7 from "./IMAGES/7 twinkle.png";
import img8 from "./IMAGES/8 twinkle.png";

const images = [img1, img2, img3, img4, img5, img6, img7, img8];

const StyledBy = () => {
  return (
    <div className="styled-container">
      {/* Header */}
      <div className="styled-header">
        <h1>Styled By SaPra</h1>
        <Link to="/shop" className="see-alls">
          See all
        </Link>{" "}
      </div>

      <p className="subtitlea">
        See How Our Beautiful Customers Styled Our Collection <br />
        For Their Weddings, Festivals, And Special Moments.
      </p>

      <div className="styled-grid">
        {/* Row 1 */}
        <div className="styled-track">
          {[...images.slice(0, 4), ...images.slice(0, 4)].map((img, i) => (
            <div className="styled-card" key={i}>
              <img src={img} alt="" />
            </div>
          ))}
        </div>

        {/* Row 2 */}
        <div className="styled-track reverse">
          {[...images.slice(4, 8), ...images.slice(4, 8)].map((img, i) => (
            <div className="styled-card" key={i}>
              <img src={img} alt="" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StyledBy;
